import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [email, setEmail] = useState('');
  const [passcode, setPasscode] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get email and passcode from the URL parameters
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const emailFromUrl = queryParams.get('email');
    const passcodeFromUrl = queryParams.get('passcode');

    if (emailFromUrl && passcodeFromUrl) {
      setEmail(emailFromUrl);
      setPasscode(passcodeFromUrl);
    }
  }, [location]);

  const handleSubmit = async () => {
    if (email === '') {
      toast.error('Please enter your email!');
      return;
    }

    if (passcode === '') {
      toast.error('Please enter your passcode!');
      return;
    }
    if (newPassword === '') {
      toast.error('Please enter your new password!');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}auth/resetpassword`, {
        email,
        passcode,
        newPassword,
      });

      if (response.data.status === 'error') {
        toast.error(response.data.message);
      } else {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (err) {
      toast.error('Error resetting password!');
      console.error('Error:', err);
    }
  };

  return (
    <div className="container-fluid Login-section">
      <div className="login-form bg-light shadow p-4 rounded position-relative">
        <div
          style={{
            position: 'fixed',  // Use fixed positioning to place it relative to the screen
            top: '10px',        // Adjust as needed for your design
            left: '10px',       // Position it in the top-left corner
            zIndex: 10,         // Ensure it's above other elements
          }}
        >
          <Link to="/" className="btn btn-success">
            <Icon.ArrowLeft className="me-2" style={{ fontSize: '1.5em' }} />
          </Link>
        </div>

        <h6 className="mb-3 fw-bold text-muted">
          <Icon.Key className="me-2" />
          Reset Password
        </h6>

        <div className="mb-3">
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            className="form-control shadow-none"
            placeholder="Enter Your Email"
          // disabled // Disable email input if email is passed via URL
          />
        </div>

        <div className="mb-3">
          <input
            type="text"
            onChange={(e) => setPasscode(e.target.value)}
            value={passcode}
            className="form-control shadow-none"
            placeholder="Enter Your Passcode"
          />
        </div>

        <div className="mb-3 position-relative">
          <input
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => setNewPassword(e.target.value)}
            value={newPassword}
            className="form-control shadow-none"
            placeholder="Enter Your New Password"
          />
          <Icon.EyeSlashFill
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={showPassword ? 'd-none' : ''}
          />
          <Icon.EyeFill
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              fontSize: '20px',
              color: '#6c757d',
            }}
            className={!showPassword ? 'd-none' : ''}
          />
        </div>

        <div className="w-100 d-flex justify-content-center mt-4">
          <button onClick={handleSubmit} className="btn btn-success w-100">
            Submit
          </button>
        </div>

        <ToastContainer theme="dark" autoClose={2000} />
      </div>
    </div>
  );
};

export default ResetPassword;



